// extracted by mini-css-extract-plugin
module.exports = {"submitted":"rating-modal_submitted__H_XRg"};